import { Component, OnInit, Type } from '@angular/core';
import { TemplateDetailsData } from '../../../../models/wizard-plugin-models/template-details-data';
import { WizardPlugin } from '../../../../decorators/wizard-plugin';
import { IWizardPluginComponent } from '../../../../interfaces/wizard-plugin-component.interface';
import { IPluginPreviewComponent } from '../../../../interfaces/plugin-preview-component.interface';
import { BasePluginData } from '../../../../models/wizard-plugin-models/base-plugin-data';
import { TemplateDetailsPreviewComponent } from './template-details-preview/template-details-preview.component';

@WizardPlugin({
  name: 'Template Details',
  optional: false,
  dataModelType: TemplateDetailsData,
})
@Component({
  selector: 'app-template-details',
  templateUrl: './template-details.component.html',
  styleUrl: './template-details.component.css'
})
export class TemplateDetailsComponent implements OnInit, IWizardPluginComponent {

  templateDetailsData: TemplateDetailsData = new TemplateDetailsData();

  constructor() {
  }

  ngOnInit(): void {
    
  }

  getPluginData(): BasePluginData {
    return this.templateDetailsData;
  }

  setPluginData(data: BasePluginData): void {
    this.templateDetailsData = data as TemplateDetailsData;
  }

  validate(): boolean {
    return 0 < this.templateDetailsData.templateName.trim().length;
  }

  isComplete(): boolean {
    return this.validate();
  }

  reset(): void {
    this.templateDetailsData = new TemplateDetailsData();
  }

  asPreview?(): Type<IPluginPreviewComponent> {
    return TemplateDetailsPreviewComponent;
  }
}
